import { PosIconProps, SvgWrapper } from './SvgWrapper';

export function ShieldCheckSolidIcon(props: Omit<PosIconProps, 'viewBox'>) {
  return (
    <SvgWrapper {...props} viewBox="0 0 31 31">
      <g clipPath="url(#clip0_5031_28435)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9561 0.38321L15.4999 0L15.0437 0.38321C11.7459 3.15358 7.36723 3.14865 3.71592 3.14453C3.57646 3.14438 3.43808 3.14422 3.30084 3.14422H2.58325V16.6337C2.58325 21.6934 5.86401 25.2829 8.98332 27.5556C10.5546 28.7005 12.1213 29.5393 13.2927 30.0916C13.8795 30.3682 14.3696 30.5741 14.7149 30.7116C14.9743 30.8148 15.2361 30.9092 15.4999 31C15.7637 30.9092 16.0256 30.8148 16.2849 30.7116C16.6303 30.5741 17.1204 30.3682 17.7071 30.0916C18.8785 29.5393 20.4452 28.7005 22.0165 27.5556C25.1358 25.2829 28.4166 21.6934 28.4166 16.6337V3.14422H27.699C27.5618 3.14422 27.4234 3.14438 27.2839 3.14453C23.6326 3.14865 19.2539 3.15358 15.9561 0.38321ZM12.8651 21.5508L23.12 10.0228L21.5257 8.54714L12.7528 18.4091L9.00456 14.7677L7.51986 16.3579L12.8651 21.5508Z"
          fill="#B1BAC2"
        />
      </g>
      <defs>
        <clipPath id="clip0_5031_28435">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </SvgWrapper>
  );
}
